<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>

<template >
  <div style="height:100%;padding:5px;text-align:center;">
    <div ref="order" v-if="true">
      <Steps :current="current" :offset-top="20">
        <Step title="工单任务"></Step>
        <Step title="任务详情"></Step>
        <Step title="详细参数"></Step>
        <Step title="操作结果"></Step>
      </Steps>
      <Modal title="Title" v-model="isModalShow" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <span>更换表具指令下发</span>
        </p>
        <Spin v-for="item in redownResult" :key="item.commandId">
          <span>{{item.commandName + " "}} {{item.msg}}</span>
          <Icon type="ios-checkmark" v-if="item.msg == '已下发'" size="18" style="margin-left:10px"></Icon>
        </Spin>
        <div slot="footer">
          <Button type="info" size="large" @click="isModalShow=false" long>确定</Button>
        </div>
      </Modal>
      <Button
        :offset-top="height * 0.15"
        v-if="showStep1"
        type="primary"
        style="right:10px;position:absolute;z-index: 999999;font-size:16px"
        shape="circle"
        icon="md-refresh"
        @click="refresh"
      ></Button>
      <div :offset-top="height * 0.15" style="height:65%;" v-show="showStep1">
        <Tabs value="name1">
          <TabPane label="安装工单" name="name1">
            <step1 ref="step1" ordertype="安装" :on-ok="callBack"></step1>
          </TabPane>
          <TabPane label="安检工单" name="name2">
            <step1 ref="step1Check" ordertype="安检" :on-ok="callBack"></step1>
          </TabPane>
          <TabPane label="维修工单" name="name3">
            <step1 ref="step1Repair" ordertype="维修" :on-ok="callBack"></step1>
          </TabPane>
        </Tabs>
      </div>

      <div :offset-top="height * 0.15" style="height:65%" v-if="showStep2">
        <checkStep2
          v-if="orderType == '安检' || orderType == '维修'"
          :item="selectedItemInfo"
          ref="step2Check"
        ></checkStep2>
      </div>
      <div :offset-top="height * 0.15" style="height:65%" v-if="showStep3">
        <step3 v-if="orderType == '安装'" ref="step3"></step3>
        <checkStep3 v-if="orderType == '安检'" ref="checkStep3"></checkStep3>
        <repairStep3 v-if="orderType == '维修'" :item="this.selectedItemInfo" ref="repairStep3"></repairStep3>
      </div>
      <div :offset-top="height * 0.15" style="height:65%" v-if="showStep4">
        <step4 ref="step4" :result="result" :msg="msg" :on-ok="callBackReturn"></step4>
      </div>

      <div :offset-top="height - 42">
        <Row>
          <Col span="12">
            <Button v-show="!showStep1  && !showStep4" type="primary" @click="pre">上一步</Button>
          </Col>
          <Col span="12">
            <Button v-show="!showStep1  && !showStep4" type="primary" @click="next">下一步</Button>
          </Col>
        </Row>
      </div>
      <Spin size="large" fix v-if="spinShow" style="z-index:999"></Spin>
    </div>
  </div>
</template>
<script>
import step3 from "../expand/InstallStep3.vue";
import step1 from "../expand/InstallStep1.vue";
import step4 from "../expand/opResult.vue";
import checkStep3 from "../expand/checkStep3.vue";
import checkStep2 from "../expand/checkStep2.vue";
import repairStep3 from "../expand/repairStep3.vue";

export default {
  mounted() {},
  created() {
    // this.height = document.body.clientHeight - 42;
    // this.width = document.body.clientWidth;
  },
  data() {
    return {
      redownResult: {},
      redownEnum: global.redownCommand,
      isModalShow: false,
      spinShow: false,
      selectedItemInfo: "",
      msg: "",
      result: "success",
      orderType: "",
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      current: 0,
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      formValidate: {
        name: "",
        mail: "",
        city: "",
        gender: "",
        interest: [],
        date: "",
        time: "",
        desc: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "The name cannot be empty",
            trigger: "blur"
          }
        ],
        mail: [
          {
            required: true,
            message: "Mailbox cannot be empty",
            trigger: "blur"
          },
          { type: "email", message: "Incorrect email format", trigger: "blur" }
        ],
        city: [
          {
            required: true,
            message: "Please select the city",
            trigger: "change"
          }
        ],
        gender: [
          { required: true, message: "Please select gender", trigger: "change" }
        ],
        interest: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "Choose at least one hobby",
            trigger: "change"
          },
          {
            type: "array",
            max: 2,
            message: "Choose two hobbies at best",
            trigger: "change"
          }
        ],
        date: [
          {
            required: true,
            type: "date",
            message: "Please select the date",
            trigger: "change"
          }
        ],
        time: [
          {
            required: true,
            type: "string",
            message: "Please select time",
            trigger: "change"
          }
        ],
        desc: [
          {
            required: true,
            message: "Please enter a personal introduction",
            trigger: "blur"
          },
          {
            type: "string",
            min: 20,
            message: "Introduce no less than 20 words",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    step3,
    step1,
    step4,
    checkStep3,
    checkStep2,
    repairStep3
  },
  methods: {
    refresh() {
      this.getOrderList();
    },
    getOrderList() {
      this.$refs.step1.request();
      this.$refs.step1Check.request();
      this.$refs.step1Repair.request();
    },
    onSwipeLeft() {
      this.showDrawer = false;
    },
    onSwipeRight() {
      this.showDrawer = true;
    },

    redownCommand(redownCommandIdArray, deviceId, newDeviceId) {
      var that = this;
      that.spinShow = true;
      $.ajax({
        url: "/api/redownCommand",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          redown: redownCommandIdArray,
          deviceId: deviceId,
          newDeviceId: newDeviceId
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });

            that.spinShow = false;
            return;
          }

          that.result = "success";
          that.msg = "设备维修更换成功<br/>请唤醒设备取回指令";
          that.redownResult = data.body;
          that.spinShow = false;
        },
        error: function(textStatus) {
          that.spinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
          that.spinShow = false;
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.$refs.step4.changeStatus(that.result);
        }
      });
    },
    commitRepair(param) {
      console.log(param);
      var that = this;
      that.spinShow = true;
      $.ajax({
        url: "/api/commitRepair",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        async: false,
        data: JSON.stringify({
          item: param
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "维修数据录入失败"
            });

            that.result = "fail";
            that.msg = "维修信息录入失败";
            that.spinShow = false;
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "维修数据录入成功"
          });

          that.result = "success";
          that.msg = "维修信息录入成功";

          that.spinShow = false;
        },
        error: function(textStatus) {
          that.spinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "维修数据录入失败"
          });

          that.spinShow = false;
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.spinShow = false;
          that.$refs.step3.changeStatus(that.result);
        }
      });
    },
    commitCheck(param) {
      var that = this;
      that.spinShow = true;
      $.ajax({
        url: "/api/commitCheck",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        async: false,
        data: JSON.stringify({
          item: that.selectedItemInfo,
          checkContent: param
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "安检数据录入失败"
            });

            that.result = "fail";
            that.msg = "设备信息录入失败<br/>请检查参数或网络";
            that.spinShow = false;
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "安检数据录入成功"
          });

          that.result = "success";
          that.msg = "安检指令已下发<br/>请在设备上查看下发结果";

          that.spinShow = false;
        },
        error: function(textStatus) {
          that.spinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "安检数据录入失败"
          });

          that.result = "fail";
          that.msg = "设备信息录入失败<br/>请检查参数或网络";
          that.spinShow = false;
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.$refs.step4.changeStatus(that.result);
        }
      });
    },
    installMeter(param) {
      console.log(this.selectedItemInfo);
      var that = this;
      that.spinShow = true;
      $.ajax({
        url: "/api/installMeter",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        async: true,
        data: JSON.stringify({
          commType: param.commType,
          manufactor: param.manufactor,
          spec: param.spec,
          meterType: param.meterType,
          gasType: param.gasType,
          meterId: param.meterId,
          base: param.base,
          remark: param.remark,
          addressId: this.selectedItemInfo.addressId,
          item: that.selectedItemInfo,
          serialNumber: param.imei,
          cardNumber: param.cardNumber
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "设备信息录入失败"
            });

            that.result = "fail";
            that.msg =
              "设备信息录入失败<br/>①请检查网络<br/>②请检查参数参数是否规范<br/>③请检查表号是否重复";
            that.spinShow = false;
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "设备数据录入成功"
          });

          that.result = "success";
          that.msg = "设备信息录入成功<br/>请提请用户前往营业厅进行开户操作";
          that.spinShow = false;
          that.getOrderList();
        },
        error: function(textStatus) {
          that.spinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "设备信息录入失败"
          });

          that.result = "fail";
          that.msg =
            "设备信息录入失败<br/>①请检查网络<br/>②请检查参数参数是否规范<br/>③请检查表号是否重复";
          that.spinShow = false;
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.$refs.step4.changeStatus(that.result);
        }
      });
    },
    callBackReturn() {
      if (this.result == "success") {
        this.current = 0;
        this.showStep1 = true;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = false;
      } else {
        this.current = 2;
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = true;
        this.showStep4 = false;
      }
    },
    callBack(item) {
      this.orderType = item.workOrderType;
      this.selectedItemInfo = item;

      if (this.orderType == "安装") {
        this.current = 1;
      }
      console.log(item);
      this.next();
    },
    next() {
      if (this.current == 3) {
        // this.current = 0;
      } else {
        if (this.current == 2) {
          // 显示遮罩层

          if (this.orderType == "安装") {
            var canInstall = true;
            this.$refs.step3.$refs.formValidate.validate(valid => {
              if (valid) {
                var formItems = this.$refs.step3.getFormItems();
                this.installMeter(formItems);
              } else {
                this.$Notice.info({
                  title: "提示",
                  desc: "参数填写不完整"
                });
                canInstall = false;
              }
            });

            if (!canInstall) {
              return;
            }
            if (!this.$refs.step3.canInstall) {
              this.$Notice.info({
                title: "提示",
                desc: "当前表具地址未被录入，无法安装"
              });
              return;
            }
          }

          if (this.orderType == "维修") {
            var canInstall = true;
            this.$refs.repairStep3.$refs.formValidate.validate(valid => {
              console.log(valid);
              if (valid) {
                canInstall = true;
              } else {
                this.$Notice.info({
                  title: "提示",
                  desc: "参数填写不完整"
                });
                canInstall = false;
              }
            });

            if (!canInstall) {
              return;
            }

            var formItems = this.$refs.repairStep3.getFormItems();

            if (formItems == null) {
              return;
            } else {
              if (
                this.$refs.repairStep3.formValidate.result == "正常维修更换"
              ) {
                this.redownCommand(
                  this.redownEnum,
                  this.selectedItemInfo.meterId,
                  formItems.newmeterId
                );
                this.isModalShow = true;
              }

              this.commitRepair(formItems);
              this.getOrderList();
            }
          }

          if (this.orderType == "安检") {
            var formItems = this.$refs.checkStep3.getFormItems();

            if (formItems == null) {
              return;
            } else {
              this.commitCheck(formItems);
              this.getOrderList();
            }
          }
        }

        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = false;

        this.current += 1;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
            break;
          case 1:
            this.showStep2 = true;
            break;
          case 2:
            this.showStep3 = true;
            // if (this.orderType == "安装") {
            //   this.$refs.step3.selectedWorkorder = this.selectedItemInfo;
            // }
            break;
          case 3:
            this.showStep4 = true;
            break;
        }
      }
    },
    pre() {
      if (this.orderType == "安装" && this.current == 2) {
        this.current = 1;
      }

      if (this.current == 0) {
      } else {
        this.current -= 1;
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = false;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
            break;
          case 1:
            this.showStep2 = true;
            break;
          case 2:
            this.showStep3 = true;
            break;
          case 3:
            this.showStep4 = true;
            break;
        }
      }
    }
  }
};
</script>

